import {
  lucideBookOpen,
  lucideLayoutGrid,
  lucidePencilRuler,
  lucideUsers
} from '@ng-icons/lucide';

export interface Menu {
  name: string;
  alias?: string;
  icon: string;
  url: string;
}

export const menu: Menu[] = [
  {
    name: 'Início',
    icon: 'lucideLayoutGrid',
    url: 'inicio'
  },
  { name: 'Materiais', icon: 'lucideBookOpen', url: 'materiais' },
  {
    name: 'Turmas',
    icon: 'lucideUsers',
    url: 'turmas'
  },
  {
    name: 'Livros',
    icon: 'lucidePencilRuler',
    url: 'livros'
  }
];

export const icons = {
  lucideLayoutGrid,
  lucideUsers,
  lucidePencilRuler,
  lucideBookOpen
};
